module.exports = __webpack_public_path__ + "static/media/9DESA10.a742bfa4.jpg";